import { render, staticRenderFns } from "./artist-options.vue?vue&type=template&id=0b8b58ab&scoped=true"
import script from "./artist-options.vue?vue&type=script&setup=true&lang=js"
export * from "./artist-options.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artist-options.vue?vue&type=style&index=0&id=0b8b58ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b58ab",
  null
  
)

export default component.exports